export const TECH_STACK = [
  { name: "React" }, { name: "Next.js" }, { name: "Node.js" }, { name: "Python" },
  { name: "PHP" }, { name: "Laravel" }, { name: "Java" }, { name: "Go" },
  { name: "Flutter" }, { name: "React Native" }, { name: "Swift" }, { name: "Kotlin" },
  { name: "AWS" }, { name: "Azure" }, { name: "GCP" },
  { name: "Docker" }, { name: "Kubernetes" }, { name: "Terraform" },
  { name: "PostgreSQL" }, { name: "MongoDB" }, { name: "MySQL" }, { name: "Redis" },
  { name: "Kafka" }, { name: "GraphQL" },
  { name: "OpenAI" }, { name: "Anthropic" }, { name: "Google Gemini" }, { name: "Hugging Face" },
  { name: "TensorFlow" }, { name: "PyTorch" }, { name: "LangChain" }, { name: "Pinecone" },
];
